/**
 * Classe de formatação do tipo Decimal
 * @author: Adalto Junior
 * DATE: 20/08/2013
 */


Monet.Format = Monet.Format|| {};
Monet.Format.DECIMAL = (function () {

    function DECIMAL(value, dataContext, entity, field, fieldInformation) {

        Monet.Format.Base.apply(this, arguments);

        this.decimalPrecision = '2';
        this.value = value;

        this.parseFloat = function () {
            const { decimalSymbol, digitalGrouping: thousandSymbol } = Monet.I18n.locale;
            const thousandSymbolRegex = new RegExp(`\\${thousandSymbol}`, 'g');
            this.value = this.value.replace(thousandSymbolRegex, '').replace(decimalSymbol, '.');

            return this;
        };

        this.setPrecision = function (precision) {

            this.decimalPrecision = precision;

            return this;
        };

        this.format = function () {
            if (this.value) {
                this.value = this.value.toLocaleString(Monet.I18n.locale.language, { minimumFractionDigits: this.decimalPrecision });
            }
            return this;
        };

        this.toGrid = function () {
            if ( fieldInformation && fieldInformation.meta ) {

                var meta = fieldInformation.meta;
                if(typeof meta === "string") {
                    meta = JSON.parse(fieldInformation.meta);
                }

                this.setPrecision(meta.precision.substr(1));
            }
            
            this.format();

            return this;

        };
    }

    return DECIMAL;

}());